import React from 'react';
import { FaEnvelope, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import Reveal from '../ui/Reveal';
import site from '../../data/site.json';
import './Contact.css';

const Contact = () => {
  return (
    <section className="contact tra-section" id="contact">
      <div className="tra-container">
        <div className="contact__grid">
          <Reveal className="contact__intro">
            <span className="tra-eyebrow">Get In Touch</span>
            <h2 className="tra-heading">Let's build something that wins</h2>
            <p className="contact__lead">
              Whether you're a brand looking to reach gamers or a creator ready to grow,
              we'd love to hear from you. Tell us about your goals.
            </p>

            <div className="contact__details">
              <a className="contact__detail" href={`mailto:${site.email}`}>
                <span className="contact__detail-icon"><FaEnvelope /></span>
                {site.email}
              </a>
            </div>

            <div className="contact__socials">
              {site.socials?.instagram && (
                <a href={site.socials.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
              )}
              {site.socials?.twitter && (
                <a href={site.socials.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a>
              )}
              {site.socials?.youtube && (
                <a href={site.socials.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a>
              )}
            </div>
          </Reveal>

          <Reveal className="contact__form-wrap" delay={0.1}>
            <form
              action={`https://formsubmit.co/${site.email}`}
              method="POST"
              className="contact__form"
            >
              <input type="hidden" name="_next" value={`${window.location.origin}/thank-you`} />
              <input type="hidden" name="_subject" value="New inquiry from ThirdRail Avenue" />
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_captcha" value="false" />
              {/* Honeypot: bots fill this, humans never see it */}
              <input
                type="text"
                name="_honey"
                tabIndex="-1"
                autoComplete="off"
                aria-hidden="true"
                style={{ display: 'none' }}
              />

              <div className="contact__row">
                <div className="contact__field">
                  <label htmlFor="name">Name</label>
                  <input type="text" id="name" name="name" required placeholder="Your name" />
                </div>
                <div className="contact__field">
                  <label htmlFor="email">Email</label>
                  <input type="email" id="email" name="email" required placeholder="you@email.com" />
                </div>
              </div>

              <div className="contact__field">
                <label htmlFor="type">I am a...</label>
                <select id="type" name="inquiry_type">
                  <option value="brand">Brand looking to run a campaign</option>
                  <option value="creator">Creator looking to join</option>
                  <option value="other">Something else</option>
                </select>
              </div>

              <div className="contact__field">
                <label htmlFor="message">Message</label>
                <textarea id="message" name="message" rows="5" required placeholder="Tell us about your goals..." />
              </div>

              <button type="submit" className="tra-btn tra-btn--primary tra-btn--lg contact__submit">
                <span className="tra-btn__label">Send Message</span>
                <span className="tra-btn__arrow" aria-hidden="true">→</span>
              </button>
            </form>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Contact;
